import type { consents as en } from '@/i18n/locales/en/consents';
import type { Translation } from '@/i18n/types';

export const consents: Translation<typeof en> = {
  title: 'Deine Zustimmungen',
  empty: 'Keine Zustimmungsanfragen betreffen dich.',
  collectiveNote:
    'Für die Abteilung gilt eine kollektive Erklärung; deine persönliche Antwort hat keine Wirkung, solange diese besteht.',
  table: {
    department: 'Abteilung',
    status: 'Status',
    basis: 'Geltende Grundlage',
  },
  status: {
    pending: 'Wartet auf deine Antwort',
    granted: 'Erteilt',
    denied: 'Abgelehnt',
  },
  basis: {
    personal: 'Persönlich',
    collective: 'Kollektiv',
  },
  actions: {
    grant: 'Zustimmen',
    deny: 'Ablehnen',
    withdraw: 'Widerrufen',
  },
};
